import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import { LifecycleManagementClient } from "@lib/ShiOneClient";
import { ApiClientConfig } from "auth/ApiClientConfig";
import { ASSET_LIFECYCLE_QUERY_KEYS } from "../constants";

export default function useGetAssetLifecycleManagementCustomerOwners(
  crmAccountId: string | undefined,
) {
  return useQuery({
    queryKey: [ASSET_LIFECYCLE_QUERY_KEYS.customerOwners, crmAccountId],
    queryFn: async () => {
      if (!crmAccountId) return null;
      const client = new LifecycleManagementClient(
        ApiClientConfig,
        import.meta.env.API_ENDPOINT,
      );
      return await client.getCustomerOwnersByCrmAccountId(crmAccountId);
    },
    refetchOnWindowFocus: false,
    staleTime: ms("1h"),
    enabled: !!crmAccountId,
  });
}
